import React, { Component } from 'react';
import { connect } from 'react-redux';

import usb from './USB.png';
import wifi from './WIFI.png';

import { saveSelectE7Wifi } from '../../lib/get-Link-fn.js';
import { LinkTabClose, StormOSLinkOpen } from '../../reducers/menus.js';
import { Modal } from 'antd';
import styles from './linkTab.css';

if (window.require != undefined) {
    var ipcRenderer = window.require('electron').ipcRenderer;
}
class LinkTab extends Component {
    constructor() {
        super()
        this.state = {
            wifiLists: {}
        }
        this.handleWIFI = this.handleWIFI.bind(this)
    }
    componentDidMount() {
        if (ipcRenderer) {
            ipcRenderer.on('E7WifiList', (event, arg) => {
                this.setState({
                    wifiLists: arg
                })
            })
        }
    }
    handleWIFI(ip) {
        this.props.close()
        saveSelectE7Wifi(ip)
    }
    render() {
        const {
            close,
            linkTab
        } = this.props
        return (
            <div>
                <Modal
                    title="设备列表"
                    width={400}
                    bodyStyle={{
                        'maxHeight': '300px',
                        'overflow': 'auto',
                        'padding': '10px'
                    }}
                    className={styles.Modals}
                    visible={linkTab}
                    footer={null}
                    onCancel={close}
                >
                    {
                        Object.keys(this.state.wifiLists).length == 0 ? "查询设备中..." : Object.keys(this.state.wifiLists).map((item, index) => {
                            return <p className={styles.wifiItem} key={index} onClick={() => { this.handleWIFI(item) }}>
                                {this.state.wifiLists[item]['name']}：{item}
                            </p>
                        })
                    }
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({

})
const mapDispatchToProps = (dispatch) => ({
    close: () => {
        dispatch(LinkTabClose())
    },
    selectWifi: () => {
        dispatch(LinkTabClose())
        dispatch(StormOSLinkOpen())
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LinkTab)
